import React from 'react';
import { Skeleton } from 'primereact/skeleton';
import 'primereact/resources/themes/lara-light-blue/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import '../../CompetitorsTab.styles.scss';
import './CompetitorsTabSkeleton.styles.scss';

const CompetitorsTabSkeleton: React.FC = () => {
  return (
    <div className="competitors-tab-skeleton">
      {/* Entry Barriers Section Skeleton */}
      <div className="entry-barriers">
        {[1, 2, 3, 4, 5].map(index => (
          <div key={index} className="barrier-metric">
            <Skeleton width="5rem" height="3rem" style={{ margin: '0 auto 0.5rem' }} />
            <Skeleton width="8rem" height="1rem" style={{ margin: '0 auto' }} />
          </div>
        ))}
      </div>

      {/* Competitor Table Section Skeleton */}
      <div className="competitor-table-skeleton">
        <Skeleton width="100%" height="20rem" borderRadius="0.75rem" />
      </div>

      {/* ANDA Section Skeleton */}
      <div className="anda-section-skeleton">
        <div className="anda-header">
          <Skeleton width="15rem" height="1.5rem" />
          <Skeleton width="20rem" height="1.5rem" />
        </div>
        <div className="anda-table-skeleton">
          <Skeleton width="100%" height="25rem" borderRadius="0.75rem" />
        </div>
      </div>
    </div>
  );
};

export default CompetitorsTabSkeleton;
